/**
 * @fileoverview Error fallback UI for EditStudentsModal.
 * Shown inside the modal when any child component crashes.
 * Prevents white screen — the user sees an error message and can close the modal.
 */
import { Center, Stack, Text } from '@mantine/core'
import { IconAlertCircle } from '@tabler/icons-react'
import { Button } from 'components'
import { useTranslation } from 'react-i18next'
import type { FC } from 'react'

const ICON_SIZE = 32

interface EditStudentsErrorFallbackProps {
  onClose: () => void
}

/** Friendly error state shown inside the modal when something goes wrong */
export const EditStudentsErrorFallback: FC<EditStudentsErrorFallbackProps> = ({ onClose }) => {
  const { t } = useTranslation()

  return (
    <Center p='xl' mih={300}>
      <Stack align='center' spacing='md'>
        <IconAlertCircle size={ICON_SIZE} color='gray' />
        <Text color='dimmed' size='sm' align='center'>
          {t('edit_students.error')}
        </Text>
        <Button variant='subtle' size='sm' onClick={onClose}>
          {t('general_buttons_close')}
        </Button>
      </Stack>
    </Center>
  )
}
